import { useEffect, useRef } from "react";
import { AccompanyingItem as AccompanyingItemType } from "./AccompanyingItem.interface";

interface Props {
    selectedItems: AccompanyingItemType[];
}

/**
 * Список выбранных товаров
 * @param selectedItems - список выбранных товаров
 * @returns 
 */
export const AccompanyingItemsSelectedItems = ({ selectedItems }: Props) => {
    const containerRef = useRef<HTMLDivElement>(null);

    //Отслеживание прокрутки списка товаров
    useEffect(() => {
        let positionX = 0;
        let isDragging = false;

        //Начало прокрутки
        const handleMouseDown = (e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            positionX = e.clientX;
            isDragging = true;
        };

        //Конец прокрутки
        const handleMouseUp = (e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            positionX = e.clientX;
            isDragging = false;
        };

        //Выход за границы контейнера
        const handleMouseLeave = (e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            isDragging = false;
        };

        //Прокрутка списка товаров
        const handleMouseMove = (e: MouseEvent) => {
            if (isDragging) {
                const deltaX = e.clientX - positionX;
                containerRef.current?.scrollBy({ left: -deltaX, behavior: 'smooth' });
            }
        };

        //Начало прокрутки
        const handleTouchStart = (e: TouchEvent) => {
            e.preventDefault();
            e.stopPropagation();
            positionX = e.touches[0].clientX;
            isDragging = true;
        };

        //Конец прокрутки
        const handleTouchEnd = (e: TouchEvent) => {
            e.preventDefault();
            e.stopPropagation();
            positionX = e.touches[0].clientX;
            isDragging = false;
        };

        //Прокрутка списка товаров
        const handleTouchMove = (e: TouchEvent) => {
            if (isDragging) {
                const deltaX = e.touches[0].clientX - positionX;
                containerRef.current?.scrollBy({ left: -deltaX, behavior: 'smooth' });
            }
        };

        containerRef.current?.addEventListener('mousedown', handleMouseDown);
        containerRef.current?.addEventListener('mousemove', handleMouseMove);
        containerRef.current?.addEventListener('mouseup', handleMouseUp);
        containerRef.current?.addEventListener('mouseleave', handleMouseLeave);
        containerRef.current?.addEventListener('touchstart', handleTouchStart);
        containerRef.current?.addEventListener('touchmove', handleTouchMove);
        containerRef.current?.addEventListener('touchend', handleTouchEnd);
        containerRef.current?.addEventListener('touchcancel', handleTouchEnd);

        return () => {
            containerRef.current?.removeEventListener('mousedown', handleMouseDown);
            containerRef.current?.removeEventListener('mousemove', handleMouseMove);
            containerRef.current?.removeEventListener('mouseup', handleMouseUp);
            containerRef.current?.removeEventListener('mouseleave', handleMouseLeave);
            containerRef.current?.removeEventListener('touchstart', handleTouchStart);
            containerRef.current?.removeEventListener('touchmove', handleTouchMove);
            containerRef.current?.removeEventListener('touchend', handleTouchEnd);
            containerRef.current?.removeEventListener('touchcancel', handleTouchEnd);
        };
    }, []);

    return (
        <div ref={containerRef}
            className="flex items-center gap-3 flex-1 bg-white rounded-lg p-3 border border-gray-200 overflow-hidden cursor-grab cursor-grabbing">
            {selectedItems.map((item, index) => <div key={item.id}>
                <div className="flex items-center gap-3">
                    <div className="flex flex-col items-center gap-2 min-w-[100px] relative group">
                        <img src={item.image} alt={item.name}
                            className="w-20 h-20 object-cover rounded-lg border transition-all shadow-sm border-gray-200 hover:border-orange-400" />
                    </div>
                    {index < selectedItems.length - 1 && <span className="text-xl font-bold text-orange-500">+</span>}
                </div>
            </div>)}
        </div>
    );
};